import React from "react";
import ReactTable from "react-table-v6";
import "react-table-v6/react-table.css";
import { RaisedButton, TextField, Paper } from "material-ui";
import { debounce } from "lodash";

const NEW_USER = "NEW";

class AuditLogTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      sorted: [],
      page: -1,
      selectedChange: "",
      selectedChange: "",
      selectedIndex: null
    };

    this._onFetchData = this._onFetchData.bind(this);
    this.processChanges = this.processChanges.bind(this);
  }

  debouncedOnFetchData = debounce(
    (page, sorted, searchValue) =>
      this.props.onFetchData(page, sorted, searchValue),
    250
  );

  _onFetchData(state, instance) {
    this.props.onFetchData(state.page, state.sorted, this.state.searchValue);
    this.setState({ page: state.page, sorted: state.sorted });
  }

  processChanges(action, changes) {
    if (changes === "") {
      return "";
    }

    let output = "";

    let changesJSON = JSON.parse(changes);
    
    if (action.indexOf("delete") !== -1) {
      output = "Object deleted:\n\n";
    }
    else if (action.indexOf("create") !== -1) {
      output = "Object created:\n\n";
    }
    else {
      output = "Object changes:\n\n";
    }

    let keys = Object.keys(changesJSON);
    keys.map(k => {
      if (k === "__v") { return; }
      if (k === "_id") { return; }
      if (k === "_owner") { return; }
      if (k === "created_at") { return; }
      if (k === "updated_at") { return; }

      if (typeof changesJSON[k] === "string") {
        output = output + `${k}: ${changesJSON[k]}\n`;
      } else if (Array.isArray(changesJSON[k])) {
        if (changesJSON[k].length === 1) {
          if (Array.isArray(changesJSON[k][0]) && changesJSON[k][0].length === 0) {
            // fall through
          }
          else {
            if (Array.isArray(changesJSON[k][0])) {
              output = output + `${k}: ${JSON.stringify(changesJSON[k][0], null, " ")}\n`;
            }
            else {
              if (typeof changesJSON[k][0] === "string") {
                output = output + `${k}: ${changesJSON[k][0]}\n`;
              }
              else {
                output = output + `${k}: ${JSON.stringify(changesJSON[k][0], null, " ")}\n`;
              }
            }
          }
        }
        else if (changesJSON[k].length > 1) {
          if (action.indexOf("delete") !== -1) {
            output = output + `${k}: ${changesJSON[k][0]}\n`;
          }
          else {
            output = output + `${k}:\n  New Value: ${changesJSON[k][1]}\n  Previous value: ${changesJSON[k][0]}\n\n`;
          }
        }
      } else {
        const objectString = JSON.stringify(changesJSON[k], null, " ");
        output = output + `${k}: ${objectString}\n`;
      }

    });

    if (changesJSON["created_at"]) {
      output = output + `\nCreated at: ${changesJSON["created_at"]}`;
    }
    if (changesJSON["updated_at"]) {
      if (Array.isArray(changesJSON["updated_at"])) {
        if (action.indexOf("delete") !== -1) {
          output = output + `\nUpdated at: ${changesJSON["updated_at"][0]}`;
        }
        else {
          output = output + `\nUpdated at: ${changesJSON["updated_at"][changesJSON["updated_at"].length-1]}`;
        }
      }
      else {
        output = output + `\nUpdated at: ${changesJSON["updated_at"]}`;
      }
    }
    output = output + "\n\nRAW JSON:\n" + changes;
    return output;
  }

  render() {
    const { logRecords, pages, pageSize, loading } = this.props;

    const columns = [
      {
        id: "user_account",
        Header: "User account",
        accessor: "user_account",
        mindWIdth: 200
      },
      //{
      //  id: "person",
      //  Header: "Person",
      //  accessor: "person"
      //},
      {
        id: "object_id",
        Header: "Object ID",
        Cell: function(data) { 
          if (data.original.action && data.original.action.indexOf(".delete") !== -1) {
            return data.original.object_id;
          }
          else if (data.original.action && data.original.action.startsWith("event_bucket.")) {
            return (<div><a href={`event_buckets/${data.original.object_id}`}>{data.original.object_id}</a></div>);
          }
          else if (data.original.action && data.original.action.startsWith("coupon.")) {
            return (<div><a href={`event_buckets/${data.original.event_bucket}/coupons/${data.original.object_id}`}>{data.original.object_id}</a></div>);
          }
          else if (data.original.action && data.original.action.startsWith("film.")) {
            return (<div><a href={`event_buckets/${data.original.event_bucket}/events/${data.original.object_id}`}>{data.original.object_id}</a></div>);
          }
          else if (data.original.action && data.original.action.startsWith("event.")) {
            return (<div><a href={`event_buckets/${data.original.event_bucket}/events/${data.original.object_id}`}>{data.original.object_id}</a></div>);
          }
          else if (data.original.action && data.original.action.startsWith("mailing.")) {
            return (<div><a href={`event_buckets/${data.original.event_bucket}/mailings/${data.original.object_id}`}>{data.original.object_id}</a></div>);
          }
          else if (data.original.action && data.original.action.startsWith("order.")) {
            return (<div><a href={`orders/${data.original.object_id}`}>{data.original.object_id}</a></div>);
          }
          else if (data.original.action && data.original.action.startsWith("pass.")) {
            return (<div><a href={`passes/${data.original.object_id}`}>{data.original.object_id}</a></div>);
          }
          else if (data.original.action && data.original.action.startsWith("pass_bucket.")) {
            return (<div><a href={`event_buckets/${data.original.event_bucket}/pass_buckets/${data.original.object_id}`}>{data.original.object_id}</a></div>);
          }
          else if (data.original.action && data.original.action.startsWith("item_bucket.")) {
            return (<div><a href={`event_buckets/${data.original.event_bucket}/item_buckets/${data.original.object_id}`}>{data.original.object_id}</a></div>);
          }
          else if (data.original.action && data.original.action.startsWith("tag.")) {
            return (<div><a href={`event_buckets/${data.original.event_bucket}/tags/${data.original.object_id}`}>{data.original.object_id}</a></div>);
          }
          else if (data.original.action && data.original.action.startsWith("ticket.")) {
            return (<div><a href={`tickets/${data.original.object_id}`}>{data.original.object_id}</a></div>);
          }
          else if (data.original.action && data.original.action.startsWith("venue.")) {
            return (<div><a href={`event_buckets/${data.original.event_bucket}/venues/${data.original.object_id}`}>{data.original.object_id}</a></div>);
          }
          else if (data.original.action && data.original.action.startsWith("virtual_content.")) {
            return (<div><a href={`ecreator_hub/virtual_content/${data.original.object_id}`}>{data.original.object_id}</a></div>);
          }
          else {
            return data.original.object_id;
          }
        }
      },
      {
        id: "action",
        Header: "Action",
        accessor: "action"
      },
      {
        id: "created_at",
        Header: "Action occurred at",
        accessor: "created_at"
      },
    ];

    return (
      <div>
        <ReactTable
          columns={columns}
          data={logRecords}
          loading={loading}
          manual
          pages={pages}
          pageSize={pageSize}
          showPageSizeOptions={false}
          onFetchData={this._onFetchData}
          sortable={false}
          getTrProps={(state, rowInfo) => {
            if (rowInfo && rowInfo.row) {
              return {
                onClick: (e) => {
                  this.setState({
                    selectedChange: JSON.stringify(
                      rowInfo.original.changes, 
                      undefined,
                      2
                    ),
                    selectedAction: rowInfo.original.action,
                    selectedIndex: rowInfo.index
                  })
                },
                style: {
                  background: rowInfo.index === this.state.selectedIndex ? '#00afec' : 'white',
                  color: rowInfo.index === this.state.selectedIndex ? 'white' : 'black'
                }
              }
            }else{
              return {}
            }
          }}
        />
        <Paper style={{ padding: 25, marginTop: 20, minHeight: 150 }} zDepth={2} >
          <pre style={{ whiteSpace: "pre-wrap" }}>{this.processChanges(this.state.selectedAction, this.state.selectedChange)}</pre>
        </Paper>

      </div>
    );
  }
}

export default AuditLogTable;



// WEBPACK FOOTER //
// ./src/app/components/partials/audit-log-table.jsx